import PropTypes from 'prop-types';
import axios from 'axios';
// @mui
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { Checkbox, Link, IconButton } from '@mui/material';
import React from 'react';
import { fDateTime } from 'src/utils/format-time';
import Iconify from 'src/components/iconify';
// ----------------------------------------------------------------------

export default function ReportsTableRow({ row, selected, onSelectRow }) {
  const { id, updatedAt, title, reportStatus, reportLink } = row;

  // functions
  const downloadLink = async () => {
    try {
      const reportBlob = await axios.get(reportLink, { responseType: 'blob' });

      const element = document.createElement('a');
      element.href = window.URL.createObjectURL(new Blob([reportBlob.data]));
      element.setAttribute('download', `${id}.xlsx`);

      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <TableRow key={id} hover selected={selected}>
      {/* <TableCell padding="checkbox">
        <Checkbox checked={selected} onClick={onSelectRow} />
      </TableCell> */}
      <TableCell sx={{ width: 250, maxWidth: 250 }}>
        <Typography variant="body2" noWrap>
          {updatedAt !== null ? fDateTime(updatedAt) : '-'}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" noWrap>
          {title}
        </Typography>
      </TableCell>
      <TableCell>
        <Typography variant="body2" noWrap>
          {reportStatus}
        </Typography>
      </TableCell>
      <TableCell sx={{ width: 200, maxWidth: 200 }}>
        <IconButton onClick={downloadLink}>
          <Iconify icon="tabler:download" />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}

ReportsTableRow.propTypes = {
  row: PropTypes.object,
  selected: PropTypes.bool,
  onSelectRow: PropTypes.func,
};
